import { create } from "zustand";
import type { ConsumerOccupancy, INovuSession } from "../services/api";

/**
 * In-memory bind of Consumer Clerk viewer → this magic link.
 * Not persisted: lifetime is this SPA tab + this Clerk session + this linkId.
 */
export interface ConsumerIdentityBind {
  clerkSessionId: string;
  linkId: string;
  occupancy: ConsumerOccupancy;
  isOccupant: boolean;
  referenceId: string;
  /** Verified CIP given name, when bind already resolved one. */
  payerFirstName?: string;
  /** In-memory Novu Inbox session. Never written to localStorage. */
  novu?: INovuSession;
}

interface ConsumerIdentityState {
  bind: ConsumerIdentityBind | null;
  setBind: (bind: ConsumerIdentityBind) => void;
  clearBind: () => void;
}

export const useConsumerIdentityStore = create<ConsumerIdentityState>(
  (set) => ({
    bind: null,
    setBind: (bind) => set({ bind }),
    clearBind: () => set({ bind: null }),
  }),
);
